import { EHeightMeasurementUnit } from "../@types";

export function convertHeight(
	value: number,
	from: EHeightMeasurementUnit,
	to: EHeightMeasurementUnit,
) {
	switch (from) {
		case EHeightMeasurementUnit.CENTIMETER:
			switch (to) {
				case EHeightMeasurementUnit.METER:
					return value * 0.01;
				case EHeightMeasurementUnit.FOOT:
					return value * 0.0328084;
				default:
					return value;
			}
		case EHeightMeasurementUnit.METER:
			switch (to) {
				case EHeightMeasurementUnit.CENTIMETER:
					return value * 100;
				case EHeightMeasurementUnit.FOOT:
					return value * 3.28084;
				default:
					return value;
			}
		case EHeightMeasurementUnit.FOOT:
			switch (to) {
				case EHeightMeasurementUnit.METER:
					return value * 0.3048;
				case EHeightMeasurementUnit.CENTIMETER:
					return value * 30.48;
				default:
					return value;
			}
		default:
			return value;
	}
}
